import edit from './edit';
import save from './save';
import accItmBdyBlockMeta from './block.json';
import { accordionIcon as icon } from './icons';
import './style.scss';

const { name, ...settings } = accItmBdyBlockMeta;
const { registerBlockType } = wp.blocks;

registerBlockType(name, {
  ...settings,
  icon,
  edit,
  save,
});
